import { cusAxios, PREFIX } from './main';

/**
 * Создает новое казино в системе
 * @param {Object} casinoInfo - Данные для создания казино
 * @param {string} casinoInfo.name - Название казино
 * @param {string} casinoInfo.groupId - Идентификатор игровой группы для регистрации новых игроков
 * @param {string[]} casinoInfo.currencyList - Массив валют в формате ["RUB","EUR","KZT"]
 * @param {Array<Object>} casinoInfo.domainList - Список доменов
 * @param {string} casinoInfo.domainList[].name - Название домена
 * @param {boolean} casinoInfo.domainList[].default - Флаг домена по умолчанию (true/false)
 * @param {Object} casinoInfo.langList - Список языков и языковых настроек. Ключом является код языка (например, "ru", "en")
 * @param {Object} casinoInfo.langList[languageCode] - Настройки для конкретного языка
 * @param {boolean} casinoInfo.langList[languageCode].default - Флаг языка по умолчанию (true/false)
 * @param {string} casinoInfo.langList[languageCode].supportChat - Название чата технической поддержки
 * @param {string} casinoInfo.langList[languageCode].supportEmail - Email технической поддержки
 * @param {string} casinoInfo.langList[languageCode].channelLink - Ссылка на Telegram-канал казино
 * @param {string} casinoInfo.langList[languageCode].chatLink - Ссылка на Telegram-чат казино
 * @param {string} casinoInfo.langList[languageCode].reviewLink - Ссылка на Telegram-канал отзывов о казино
 * @param {string} casinoInfo.langList.<languageCode>.postLink - Ссылка на Telegram-пост для игрового сайта
 */

const createCasino = async (casinoInfo) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/create`,
    data: casinoInfo
  });
  return response;
};

const updateCasino = async (casinoInfo) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/update`,
    data: casinoInfo
  });
  return response;
};

/**
 * Получение параметров казино
 * @param {Object} props - Данные для создания казино
 * @param {string} props.casinoId - Данные для создания казино
 * @param {Object} props.propsCasino - Данные для создания казино
 * @param {string} propsCasino.name - Название казино
 * @param {string} propsCasino.groupId - Идентификатор игровой группы для регистрации новых игроков
 * @param {string[]} propsCasino.currencyList - Массив валют в формате ["RUB","EUR","KZT"]
 * @param {Array<Object>} propsCasino.domainList - Список доменов
 * @param {Object} propsCasino.langList - Список языков и языковых настроек. Ключом является код языка (например, "ru", "en")
 */
const getCasinoProps = async ({ casinoId, propsCasino = [] }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/info`,
    data: { casinoId, props: propsCasino }
  });
  return response;
};

const getAgreement = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/agreement_list`,
    data: { casinoId }
  });
  return response;
};

const setAgreement = async ({ casinoId, text }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/agreement_set`,
    data: { casinoId, text }
  });
  return response;
};

const getCasinoBannerList = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/banner_list`,
    data: { casinoId }
  });
  return response;
};

const setCasinoBanner = async ({ casinoId, list }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/banner_set`,
    data: { casinoId, list }
  });
  return response;
};

const getConfigCasino = async ({ casinoId, config }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/config_get`,
    data: { casinoId, config }
  });
  return response;
};

const setConfigCasino = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/config_set`,
    data: { casinoId, data }
  });
  return response;
};

/**
 * Получение параметров казино
 * @param {Object} props - Данные для создания казино
 * @param {string} props.casinoId - Числовой идентификатор казино
 * @param {'input' | 'output'} props.type - Тип лимитов
 */
const getLimitCasino = async ({ casinoId, type }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/inoutlimit_get`,
    data: { casinoId, type }
  });
  return response;
};

const setLimitCasino = async ({ casinoId, type, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/inoutlimit_set`,
    data: { casinoId, type, data }
  });
  return response;
};

const getCascadeProvider = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/inputcascade_get`,
    data: { casinoId }
  });
  return response;
};

const setCascadeProvider = async ({ casinoId, cascade }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/inputcascade_set`,
    data: { casinoId, cascade }
  });
  return response;
};

const getTgBot = async ({ casinoId, lang }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/telegrambot_get`,
    data: { casinoId, lang }
  });
  return response;
};
const setTgBot = async ({ casinoId, botName, apiToken, secretToken, supportInvite }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/telegrambot_set`,
    data: { casinoId, botName, apiToken, secretToken, supportInvite }
  });
  return response;
};

const getNotifyTg = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/usernotice_get`,
    data: { casinoId }
  });
  return response;
};

const setNotifyTg = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/usernotice_set`,
    data: { casinoId, data }
  });
  return response;
};

const getNotifyManagerTg = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/mgrnotice_get`,
    data: { casinoId }
  });
  return response;
};

const setNotifyManagerTg = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/mgrnotice_set`,
    data: { casinoId, data }
  });
  return response;
};

const setLogo = async ({ casinoId, fileName, fileData }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/logo_set`,
    data: { casinoId, fileName, fileData }
  });
  return response;
};
const deleteLogo = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/logo_delete`,
    data: { casinoId }
  });
  return response;
};

const getColor = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/color_get`,
    data: { casinoId }
  });
  return response;
};

const setColor = async ({ casinoId, colorList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/color_set`,
    data: { casinoId, colorList }
  });
  return response;
};

const getHtmlCode = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/htmlcode_get`,
    data: { casinoId }
  });
  return response;
};
const getHeadData = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/headdata_get`,
    data: { casinoId }
  });
  return response;
};

const setHeadData = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/headdata_set`,
    data: { casinoId, data }
  });
  return response;
};

const setHtmlCode = async ({ casinoId, innerHead, beforeEndBody }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/htmlcode_set`,
    data: { casinoId, code: { innerHead, beforeEndBody } }
  });
  return response;
};

const getLiveChat = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/livechat_get`,
    data: { casinoId }
  });
  return response;
};

const setLiveChat = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/livechat_set`,
    data: { casinoId, data }
  });
  return response;
};

const getGamestat = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/gamestat_get`,
    data: { casinoId }
  });
  return response;
};

const setGamestat = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/gamestat_set`,
    data: { casinoId, data }
  });
  return response;
};

const getCaptcha = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/captcha_get`,
    data: { casinoId }
  });
  return response;
};

const setCaptcha = async ({ casinoId, data }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/captcha_set`,
    data: { casinoId, data }
  });
  return response;
};

const deleteCasino = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/delete`,
    data: { casinoId }
  });
  return response;
};

const getAuthParamCasino = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/regauth_get`,
    data: { casinoId }
  });
  return response;
};

const setAuthParamCasino = async ({
  casinoId,
  emailRegEnabled,
  emailVerifyRequire,
  phoneRegEnabled,
  tgRegEnabled
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/regauth_set`,
    data: { casinoId, emailRegEnabled, emailVerifyRequire, tgRegEnabled, phoneRegEnabled }
  });
  return response;
};

const setTgMenuNames = async ({ casinoId, lang, commands }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/telegrambot_menu_set`,
    data: { casinoId, lang, commands }
  });
  return response;
};

const createRabittMq = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/rmq_create`,
    data: { casinoId }
  });
  return response;
};

const getRabittMq = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/rmq_get`,
    data: { casinoId }
  });
  return response;
};

const deleteRabittMq = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/rmq_delete`,
    data: { casinoId }
  });
  return response;
};

const keyGet = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/game_api_get`,
    data: { casinoId }
  });
  return response;
};

const keySet = async ({ casinoId, gameApiKey }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/casino/game_api_set`,
    data: { casinoId, gameApiKey }
  });
  return response;
};

export const API_CASINO = {
  create: createCasino,
  update: updateCasino,
  agreement: { get: getAgreement, set: setAgreement },
  banners: { list: getCasinoBannerList, set: setCasinoBanner },
  get: { props: getCasinoProps },
  config: { get: getConfigCasino, set: setConfigCasino },
  limit: { get: getLimitCasino, set: setLimitCasino },
  cascade: { get: getCascadeProvider, set: setCascadeProvider },
  tgCasino: { get: getTgBot, set: setTgBot },
  tgNotify: {
    players: { get: getNotifyTg, set: setNotifyTg },
    managers: { get: getNotifyManagerTg, set: setNotifyManagerTg }
  },
  logo: { set: setLogo, del: deleteLogo },
  color: { get: getColor, set: setColor },
  headData: { get: getHeadData, set: setHeadData },
  insertHtml: { get: getHtmlCode, set: setHtmlCode },
  liveChat: { get: getLiveChat, set: setLiveChat },
  gamestat: { get: getGamestat, set: setGamestat },
  captcha: { get: getCaptcha, set: setCaptcha },
  auth: { get: getAuthParamCasino, set: setAuthParamCasino },
  rabittMq: { create: createRabittMq, get: getRabittMq, delete: deleteRabittMq, keyGet, keySet },
  setTgMenuNames,
  delete: deleteCasino
};
